import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "refresh",
  "use": "refresh-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"refresh\"><path fill-rule=\"evenodd\" d=\"M14.94 5.041A7 7 0 1 0 17 10h-1a6 6 0 1 1-1.766-4.251L11.987 8h4.991V3l-2.037 2.041Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol